import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { map, of, switchMap } from 'rxjs';
import { unique } from '../lib/unique';
import { PICFLOW_STORYBLOK } from '../picflow-storyblok';

export const storyblokArticleTopicsResolver: ResolveFn<unknown> = route => {
  const storyblokService = inject(PICFLOW_STORYBLOK);

  return storyblokService.getUniqueComponentsList(route).pipe(
    switchMap(components => {
      if (!components.has('BlogPostLinkList') && !components.has('LatestBlogPosts')) return of(undefined);
      return storyblokService.getStories({ content_type: 'ArticleTopic' }, route).pipe(
        switchMap(resp => {
          const topics = resp.stories;
          const pageUuids = unique(topics.map(topic => topic.content.page).filter(Boolean));
          if (!pageUuids.length) return of(topics);
          return storyblokService.getStories({ by_uuids: pageUuids.join(',') }).pipe(
            map(pageResp => {
              const pages = pageResp.stories;
              return topics.map(topic => ({
                ...topic,
                content: {
                  ...topic.content,
                  page_url: pages.find(page => page.uuid === topic.content.page)?.full_slug,
                },
              }));
            })
          );
        })
      );
    })
  );
};
